import styled, { css } from "styled-components";
import { fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const Content = styled.div``;

export const TextWrapper = styled.div<{ isOpen: boolean }>`
  overflow: hidden;
  margin-top: 16px;
  height: ${(props) => (props.isOpen ? "auto" : "225px")}
    ${(props) =>
      !props.isOpen &&
      css`
        display: -webkit-box;
        -webkit-line-clamp: 9;
        -webkit-box-orient: vertical;
      `};

  ${breakpoints.smDown} {
    height: ${(props) => (props.isOpen ? "auto" : "180px")};
  }
`;

export const Text = styled.div`
  font-family: ${fonts.fontBauRegular};
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  white-space: break-spaces;

  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const SeeMore = styled.div`
  cursor: pointer;
  font-family: ${fonts.fontBauMedium};
  text-align: center;
  text-decoration-line: underline;
  user-select: none;
  font-size: 16px;
  margin-top: 16px;
  margin-bottom: 12px;
  line-height: 23px;

  ${breakpoints.smDown} {
    font-size: 12px;
    line-height: 17px;
  }
`;

export const SectionTitle = styled.div`
  font-family: ${fonts.fontBauMedium};
  text-transform: uppercase;
  font-size: 18px;

  ${breakpoints.smDown} {
    font-size: 14px;
  }
`;
